import React, { FunctionComponent } from 'react';
import { Grid, makeStyles, Typography } from '@rbx/ui';
import CodeBlock, { TCodeBlockProps } from '@modules/ui/codeBlock/CodeBlock';
import { useAppConfig } from '@modules/layout/layout/components/AppConfigProvider';

const useStyles = makeStyles<{ enableNewLayout: boolean }>()((theme, { enableNewLayout }) => ({
  codeSample: {
    marginTop: 40,
    '&:first-child': {
      marginTop: 0,
    },
  },

  content: {
    paddingRight: 24,
    [theme.breakpoints.down('XLarge')]: {
      paddingRight: 0,
    },
  },
  codeSampleContainer: {
    width: '100%',
    top: 24,
    marginTop: enableNewLayout ? undefined : 70,
    [theme.breakpoints.up('XLarge')]: {
      position: 'sticky',
    },
  },
  codeSampleSection: {
    paddingLeft: 24,
    [theme.breakpoints.down('XLarge')]: {
      paddingLeft: 0,
    },
    '& span': {
      fontSize: 14,
    },
  },
}));

export interface RoasLayoutProps {
  codeSamples?: TCodeBlockProps[];
  className?: string;
  codeClassName?: string;
  resourceName: string;
  showResourceName?: boolean;
}

const Layout: FunctionComponent<React.PropsWithChildren<RoasLayoutProps>> = ({
  children,
  codeSamples,
  className,
  codeClassName,
  resourceName,
  showResourceName = false,
}) => {
  const { enableNewLayout } = useAppConfig();
  const {
    classes: {
      content: contentStyle,
      codeSampleSection,
      codeSample: codeSampleStyle,
      codeSampleContainer,
    },
    cx,
  } = useStyles({ enableNewLayout: Boolean(enableNewLayout) });

  return (
    <Grid container className={className} direction='row'>
      <Grid XSmall={12} XLarge={6} item className={contentStyle} container direction='column'>
        {showResourceName && (
          <Typography
            id={resourceName}
            paddingTop={enableNewLayout ? undefined : 8}
            marginBottom={2}
            variant='h1'
            component='h1'>
            {resourceName}
          </Typography>
        )}
        {children}
      </Grid>
      <Grid XSmall={12} XLarge={6} className={cx(codeSampleSection, codeClassName)}>
        <div className={codeSampleContainer}>
          {codeSamples &&
            codeSamples.map(({ title = '', content = '', language, ...otherProps }, idx) => (
              <CodeBlock
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                enableExpand
                enableCopy
                title={title}
                content={content}
                language={language}
                fullWidth
                className={codeSampleStyle}
                {...otherProps}
              />
            ))}
        </div>
      </Grid>
    </Grid>
  );
};

export default Layout;
